import React from "react";
import { Icon, IconProps } from "../Icon";
/**
 * @group Icons
 */
export function LightbulbIcon(props: IconProps) {
    return <Icon {...props} iconKey={"lightbulb"}/>
}
